import React from 'react';

import CountUp from 'react-countup';

import { type BaseCurrencyType } from '@pkg/types';

interface CurrencyCountupProps {
    title?: string;
    value: number;
    currency: BaseCurrencyType;
}

export const CurrencyCountup = ({ title, value, currency }: CurrencyCountupProps) => {
    return (
        <span title={title}>
            <CountUp
                end={value}
                decimal="."
                prefix={currency === 'usd' ? '$' : ''}
                decimals={currency === 'usd' ? 2 : 4}
                preserveValue
            />
        </span>
    );
};
